document.addEventListener('DOMContentLoaded', () => {
    const inputs = document.querySelectorAll('.js-text-counter');
    inputs.forEach((input, index) => {
        const counterId = input.getAttribute('data-counter');
        const counter = document.getElementById(counterId);
        input.addEventListener("input", () => {
            const maxLength = input.getAttribute("maxlength");
            const currentLength = input.value.length;
            if (typeof counter !== 'undefined' && counter !== null) {
                counter.textContent = maxLength - currentLength;
            }
        });
    });
});
